/**
 * Route guard. Refreshes the auth store on first mount, then:
 *   - if not logged in → /login
 *   - if logged in but wrong role → /
 *   - otherwise renders children
 */
import { useEffect, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, type UserRole } from '../stores/auth';
import { MobileNav } from './MobileNav';

interface Props {
  role?: UserRole;
  children: ReactNode;
}

export function ProtectedRoute({ role, children }: Props) {
  const { user, initialized, loading, refresh } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!initialized) {
      void refresh();
    }
  }, [initialized, refresh]);

  if (!initialized || loading) {
    return (
      <main className="page-center">
        <div className="loading" role="status" aria-label="불러오는 중">
          <span>Loading…</span>
        </div>
      </main>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (role && user.role !== role) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {children}
      <MobileNav />
    </>
  );
}
